import fontawesome from '../util/fontawesome'
import owlcarousel from '../util/owlcarousel'

export default {
  init() {
    // JavaScript to be fired on all pages
    fontawesome()

    owlcarousel()
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js